/**
 * @generated SignedSource<<24eaa9c5c646056f92794e5957f494d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type useRoutineEditDirty_Routine$data = {
  readonly activeVersion: {
    readonly connections: ReadonlyArray<{
      readonly canBeDisabled: boolean | null;
      readonly ordinal: number;
      readonly orgTopic: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      } | null;
      readonly sectionId: string;
      readonly taskId: string;
    }>;
    readonly sections: ReadonlyArray<{
      readonly orgCanBeDisabled: boolean | null;
      readonly orgTopic: {
        readonly id: string;
      } | null;
      readonly section: {
        readonly assignedTeam: {
          readonly id: string;
        } | null;
        readonly id: string;
        readonly title: string | null;
      };
    }>;
    readonly tasks: ReadonlyArray<{
      readonly __typename: string;
      readonly goals?: ReadonlyArray<{
        readonly greaterThan: number | null;
        readonly lessThan: number | null;
        readonly section: {
          readonly id: string;
        };
      }>;
      readonly id: string;
      readonly images: ReadonlyArray<{
        readonly id: string;
        readonly size: {
          readonly height: number;
          readonly id: string;
          readonly url: string;
          readonly width: number;
        } | null;
      }>;
      readonly instructions: string | null;
      readonly sentiments?: ReadonlyArray<TaskSentiment>;
      readonly title: string;
      readonly unit?: NumberTaskUnit;
    }>;
  };
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
    };
  }>;
  readonly currentSchedule: {
    readonly __typename: "RoutineScheduleDaily";
    readonly deadlineDuration: number | null;
    readonly isAllDay: boolean | null;
    readonly weekdays: ReadonlyArray<{
      readonly startTime: {
        readonly hour: number;
        readonly minute: number;
      } | null;
      readonly tasks: ReadonlyArray<{
        readonly importance: TaskImportance;
        readonly taskId: string;
      }>;
      readonly weekday: number;
    }>;
  } | {
    readonly __typename: "RoutineScheduleMonthly";
    readonly endDay: number | null;
    readonly months: ReadonlyArray<number>;
    readonly startDay: number;
  } | {
    readonly __typename: "RoutineScheduleWeekly";
    readonly endWeekday: number | null;
    readonly startWeekday: number | null;
    readonly weeks: ReadonlyArray<number>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly description: string | null;
  readonly ownerTeam: {
    readonly id: string;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "useRoutineEditDirty_Routine";
};
export type useRoutineEditDirty_Routine$key = {
  readonly " $data"?: useRoutineEditDirty_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRoutineEditDirty_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRoutineEditDirty_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instructions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "minHeight",
                      "value": 700
                    },
                    {
                      "kind": "Literal",
                      "name": "minWidth",
                      "value": 700
                    }
                  ],
                  "concreteType": "ImageSize",
                  "kind": "LinkedField",
                  "name": "size",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "width",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "height",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "size(minHeight:700,minWidth:700)"
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentiments",
                  "storageKey": null
                }
              ],
              "type": "TaskCheck",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskNumberGoals",
                  "kind": "LinkedField",
                  "name": "goals",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "greaterThan",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lessThan",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoutineSection",
                      "kind": "LinkedField",
                      "name": "section",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unit",
                  "storageKey": null
                }
              ],
              "type": "TaskNumber",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskSectionConnection",
          "kind": "LinkedField",
          "name": "connections",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sectionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ordinal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canBeDisabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgTopic",
              "kind": "LinkedField",
              "name": "orgTopic",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "orgCanBeDisabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgTopic",
              "kind": "LinkedField",
              "name": "orgTopic",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineSection",
              "kind": "LinkedField",
              "name": "section",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "assignedTeam",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineDuration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineScheduleDailyWeekday",
              "kind": "LinkedField",
              "name": "weekdays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Time",
                  "kind": "LinkedField",
                  "name": "startTime",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hour",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minute",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weekday",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineScheduleTaskImportance",
                  "kind": "LinkedField",
                  "name": "tasks",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importance",
                      "storageKey": null
                    },
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleDaily",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWeekday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endWeekday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weeks",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleWeekly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "months",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleMonthly",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "24ed90abd7dbedfe317618a96ab4bcb9";

export default node;
